import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LineGuidedtoursIcon from 'LuxKit/Icons/line/LineGuidedtoursIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineCommentsAltIcon from 'LuxKit/Icons/line/LineCommentsAltIcon'
import LineBedQueenIcon from 'LuxKit/Icons/line/LineBedQueenIcon'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import Group from 'components/utils/Group'

const TourUSPSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(5, 260px);
  grid-auto-columns: 100%;
  gap: ${rem(24)};
  align-items: start;
  height: fit-content;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
  }
`

function TourUSPContainer() {
  return (
    <Group direction="vertical" gap={20}>
      <Heading variant="heading2">
        <FormattedMessage
          id="ZxmO/oBWCM"
          defaultMessage="Luxury Escapes Tours give you <i>more</i>"
          description="Main heading for tours USP section highlighting what Luxury Escapes Tours offer"
          values={{ i: (chunks: React.ReactNode) => <i>{chunks}</i> }}
        />
      </Heading>
      <TourUSPSection>
        <VerticalSpacer gap={8}>
          <LineStarIcon size="L" />
          <BodyText variant="medium" weight="bold">
            <FormattedMessage
              id="LOLWt5XqdV"
              defaultMessage="Exclusive tours, designed by our experts"
              description="USP heading about expert-designed exclusive tours"
            />
          </BodyText>
          <BodyText variant="medium">
            <FormattedMessage
              id="2g+xR+g0C8"
              defaultMessage="Discover curated itineraries and handpicked experiences with tours designed by our team of travel experts."
              description="USP description about expert-designed exclusive tours"
            />
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineGuidedtoursIcon size="L" />
          <BodyText variant="medium" weight="bold">
            <FormattedMessage
              id="IDTkWNnZ0T"
              defaultMessage="Immersive small-group adventures"
              description="USP heading about small-group tour adventures"
            />
          </BodyText>
          <BodyText variant="medium">
            <FormattedMessage
              id="ZvQWTg1mHA"
              defaultMessage="Enjoy an intimate look at destinations across the globe with small-group journeys comprised of 24 travellers or less."
              description="USP description about small-group tour adventures"
            />
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineUsersAltIcon size="L" />
          <BodyText variant="medium" weight="bold">
            <FormattedMessage
              id="CzXq/ulCyp"
              defaultMessage="Guaranteed two-person departures"
              description="USP heading about guaranteed departures with minimum two travellers"
            />
          </BodyText>
          <BodyText variant="medium">
            <FormattedMessage
              id="ssb9eVJJcp"
              defaultMessage="Book your tour with confidence, knowing that we only require a minimum of two travellers to guarantee your departure."
              description="USP description about guaranteed departures with minimum two travellers"
            />
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineBedQueenIcon size="L" />
          <BodyText variant="medium" weight="bold">
            <FormattedMessage
              id="o5iQb39Teh"
              defaultMessage="Exceptional quality at unbeatable value"
              description="USP heading about high quality tours at great prices"
            />
          </BodyText>
          <BodyText variant="medium">
            <FormattedMessage
              id="+TMJL0gMEp"
              defaultMessage="Experience top-notch tours with 4 and 5-star accommodation and curated experiences that prioritise value without compromising on quality."
              description="USP description about high quality tours at great prices"
            />
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={8}>
          <LineCommentsAltIcon size="L" />
          <BodyText variant="medium" weight="bold">
            <FormattedMessage
              id="HN4R6bwieO"
              defaultMessage="Dedicated tours concierge"
              description="USP heading about dedicated concierge support for tours"
            />
          </BodyText>
          <BodyText variant="medium">
            <FormattedMessage
              id="kFNo7hWWyl"
              defaultMessage="From start to finish, our team is there with you, ensuring a seamless and exceptional experience from booking up until the end of your tour."
              description="USP description about dedicated concierge support for tours"
            />
          </BodyText>
        </VerticalSpacer>
      </TourUSPSection>
    </Group>
  )
}

export default TourUSPContainer
